import React from 'react';
import { TextInputWUT } from '../../../inputs/text-input-wut/text-input-wut';
import { useFieldAttributes } from '../../../services/field-attributes';
import { ChallengesQuestionWut } from '../../../ui/challenges/challenges-question/challenges-question-wut';
import { FieldAnswerFeedbackWUT } from '../../../ui/field-answer-feedback/field-answer-feedback-wut';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
export const ChallengesShortTextWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel = false,
    placeholder,
    required = true,
    description,
    value = '',
    onChange,
    onBlur,
    onFocus,
    error,
    hasError = false,
    errorMessage,
    type = 'text',
    disabled = false,
    readOnly,
    prefix,
    externalData,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    questionImage,
    questionImageResize,
    questionImageAlignment,
    questionImagePlacement,
    questionImageAltText
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(ChallengesQuestionWut, {
      htmlFor: inputId,
      labelId: labelId,
      id: id,
      error: error,
      description: description,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement,
      image: questionImage,
      imageResize: questionImageResize,
      imageAlignment: questionImageAlignment,
      imagePlacement: questionImagePlacement,
      imageAltText: questionImageAltText
    }),
    renderInput: () => /*#__PURE__*/React.createElement(TextInputWUT, {
      label: label,
      placeholder: placeholder,
      required: required,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      type: type,
      disabled: disabled,
      readOnly: readOnly,
      prefix: prefix,
      inputId: inputId,
      ariaDescribedBy: ariaDescribedBy,
      hasError: hasError,
      fieldId: id
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), /*#__PURE__*/React.createElement(FieldAnswerFeedbackWUT, {
      target: target,
      externalData: externalData
    }))
  });
};
//# sourceMappingURL=challenges-short-text-wut.js.map